<h1>Clothing for Sale</h1>
<div *ngFor="let doc of myArray">
    <div class="listing media" id = "listing-preview" *ngIf="doc.itemStatus === 'For Sale'">
        <div class="photo">
            <img id="images" src={{doc.imageURL}} alt="listing image" required/> 
        </div>

        <div class="content media-body">
            <!-- Book Elements in Preview-->
            <h2><strong>{{doc.listingTitle}}</strong></h2> 
            <h4><strong>Price:</strong> ${{doc.price}}</h4>
            <br>
            <p><strong>Type: </strong>{{doc.type}} <strong>Color: </strong>{{doc.color}}</p>
            <br> 
            <p><strong>Size: </strong>{{doc.size}}</p> 
            <br>
            <p><strong>Description: </strong>{{doc.description}}</p>
            <br>
            <p><strong>Item Status: </strong>{{doc.itemStatus}}</p>
            <br>
            <p><strong>Exchange Location: </strong>{{doc.exchangeLoc}} <strong>Payment Option:</strong> {{doc.paymentOpt}}</p>
            <br>
            <p><strong>Seller: </strong>{{doc.email}}</p>
            <button class="button" mdbBtn type="button" mdbWavesEffect (click)="cart.addToCart(doc)">Add To Cart</button>
        </div>
    </div>
</div>

